// Full-screen block shown when the phone has NO internet at all.
// Weak connections stay "online", so the stored copy keeps the app fast.
import { useEffect, useState } from "react";
import { WifiOff, RefreshCw } from "lucide-react";

export default function OfflineBanner() {
  const [online, setOnline] = useState(() => typeof navigator === "undefined" || navigator.onLine !== false);
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    const up = () => setOnline(true);
    const down = () => setOnline(false);
    window.addEventListener("online", up);
    window.addEventListener("offline", down);
    return () => { window.removeEventListener("online", up); window.removeEventListener("offline", down); };
  }, []);

  const retry = () => {
    setChecking(true);
    setTimeout(() => { setOnline(navigator.onLine !== false); setChecking(false); }, 800);
  };

  if (online) return null;
  return (
    <div dir="rtl" className="fixed inset-0 z-[10000] bg-background flex flex-col items-center justify-center text-center px-8 gap-4" data-testid="offline-screen">
      <div className="size-24 rounded-full bg-amber-500/15 border-2 border-amber-500/40 flex items-center justify-center">
        <WifiOff className="size-11 text-amber-500" />
      </div>
      <h1 className="text-2xl font-black" data-testid="offline-title">لا يوجد اتصال بالإنترنت</h1>
      <p className="text-sm text-muted-foreground max-w-xs">هاتفك غير متصل بالإنترنت. شغّل البيانات أو الواي فاي ثم حاول مرة أخرى.</p>
      <button onClick={retry} data-testid="offline-retry-btn"
        className="mt-2 inline-flex items-center gap-2 h-12 px-6 rounded-full bg-primary text-primary-foreground font-black active:scale-95 transition-transform">
        <RefreshCw className={`size-4 ${checking ? "animate-spin" : ""}`} />إعادة المحاولة
      </button>
    </div>
  );
}
